const loaderOverride = {
  display: "block",
  marginTop: "10%",
  marginLeft: "50%",
  marginRight: "40%",
};

export { loaderOverride };